// extracted by mini-css-extract-plugin
export default {"dark":"DeleteUser_dark__qbzM7","App":"DeleteUser_App__ReqPs","confirmDelete":"DeleteUser_confirmDelete__zWNxb"};